import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';

interface FilterChip {
  id: string;
  label: string;
  count: number;
  variant: 'default' | 'secondary' | 'destructive' | 'outline';
  icon: string;
  color: string;
}

interface SmartFilterChipsProps {
  filters: FilterChip[];
  activeFilter: string | null;
  onFilterChange: (filterId: string | null) => void;
  className?: string;
}

export const SmartFilterChips: React.FC<SmartFilterChipsProps> = ({
  filters,
  activeFilter,
  onFilterChange,
  className = ''
}) => {
  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      <Button
        variant={activeFilter === null ? 'default' : 'outline'}
        size="sm"
        onClick={() => onFilterChange(null)}
        className="flex items-center gap-2"
      >
        <i className="fa-solid fa-list"></i>
        Alle
      </Button>
      
      {filters.map((filter) => (
        <Button
          key={filter.id}
          variant={activeFilter === filter.id ? 'default' : 'outline'}
          size="sm"
          onClick={() => onFilterChange(filter.id)}
          className="flex items-center gap-2"
          style={{
            backgroundColor: activeFilter === filter.id ? filter.color : undefined,
            borderColor: filter.color,
            color: activeFilter === filter.id ? 'white' : filter.color
          }}
        >
          <i className={filter.icon}></i>
          {filter.label}
          <Badge 
            variant="secondary" 
            className="ml-1"
            style={{
              backgroundColor: activeFilter === filter.id ? 'rgba(255,255,255,0.2)' : undefined,
              color: activeFilter === filter.id ? 'white' : undefined
            }}
          >
            {filter.count}
          </Badge>
        </Button>
      ))}
    </div>
  );
};
